module.exports = "/shifts/components/schedulingConflictsComponent-274a1e.html";